import * as React from 'react';
import { LineItem, LineItemMedia, LineItemContent, LineItemAside } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const Product = ({ body , imageUrl , price , title , quotation  })=>{
    return /*#__PURE__*/ React.createElement(LineItem, {
        className: "mini-cart-v2__product"
    }, /*#__PURE__*/ React.createElement(LineItemMedia, {
        className: "mini-cart-v2__product--image",
        type: "image",
        imageUrl: imageUrl,
        imageAlt: title
    }), /*#__PURE__*/ React.createElement(LineItemContent, {
        title: title,
        body: body
    }), /*#__PURE__*/ React.createElement(LineItemAside, {
        currency: price.currency,
        price: price.originalPrice,
        discountPrice: price.discountedPrice
    }), quotation.isEnabled && /*#__PURE__*/ React.createElement(Text, {
        className: "mini-cart-v2__product--quotation",
        component: "p",
        variant: "body"
    }, quotation.text));
};

export { Product };
//# sourceMappingURL=Product.js.map
